import { render } from "./HowErp.vue?vue&type=template&id=7c74ae01"
import script from "./HowErp.vue?vue&type=script&lang=js"
export * from "./HowErp.vue?vue&type=script&lang=js"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__